module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-4.1f91b46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-4.jpg
// module id = dlDG
// module chunks = 1